import { Api } from '../utility/client';

import type { RoleMap } from '../../types';

export const getOrgRolesMap = async (orgId: string) => {
  const res = await Api.get<RoleMap>(`/v1/orgs/${orgId}/roles-map`);
  return res.data;
};
